<script setup>
import Badge from "./Badge.vue";

defineProps({
    badgeText: String,
    badgeColor: {
        default: "gray",
        type: String,
    },
});
</script>

<template>
    <header>
        <div class="flex items-center justify-between bg-slate-900 px-4 py-2 sm:px-4 md:py-3 xl:px-6 2xl:px-8">
            <div class="min-w-0 flex-1">
                <div class="flex items-center space-x-2 py-2">
                    <img
                        v-if="$page.props.event_logo"
                        :src="$page.props.event_logo"
                        class="mr-2 inline-block max-h-28 max-w-40 rounded text-center md:h-20 lg:mr-4"
                        alt="Event logo"
                    />
                    <div class="space-y-1.5">
                        <h1 class="text-white md:truncate md:tracking-tight">
                            <slot name="title" />
                        </h1>
                        <Badge
                            v-if="badgeText"
                            :color="badgeColor"
                            >{{ badgeText }}
                        </Badge>
                        <slot name="badges" />
                    </div>
                </div>
            </div>
            <div class="my-4 ml-4 hidden gap-2 md:my-0 md:flex">
                <slot name="buttons" />
            </div>
        </div>
    </header>
</template>
